module.exports = __webpack_public_path__ + "a71824b4ea34fa90ee9cdc72fb33034b.svg";